module.exports = __webpack_public_path__ + "img/center back length to underbust.dbac5779.png";